/**
 * CZNA-554 — the per-user "new since you last opened the queue" flag, on top of the count.
 *
 * <p>`useReviewQueueNewItems` reads it (landing page); `useMarkReviewQueueSeen` advances the
 * marker while the supervisor queue is open. Both reuse `useReviewQueueCount`, so the flag
 * costs no request beyond the one the count already makes.
 */
import { useEffect } from 'react';
import { useStripes } from '@folio/stripes/core';
import { useReviewQueueCount } from './useReviewQueueCount';
import { hasNewSinceLastSeen, markReviewQueueSeen, readReviewQueueLastSeen, } from '../utils/reviewQueueLastSeen';
var useCurrentUserId = function () { var _a, _b; return (_b = (_a = useStripes().user) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.id; };
export var useReviewQueueNewItems = function (enabled) {
    var userId = useCurrentUserId();
    var _a = useReviewQueueCount(enabled), count = _a.count, newestWaitingSince = _a.newestWaitingSince;
    // Without a user id there is nowhere to remember "seen", and a flag that can never be
    // cleared is noise — so no flag at all.
    var hasNew = enabled
        && Boolean(userId)
        && hasNewSinceLastSeen(newestWaitingSince, readReviewQueueLastSeen(userId));
    return { count: count, hasNew: hasNew };
};
export var useMarkReviewQueueSeen = function (enabled) {
    var userId = useCurrentUserId();
    var newestWaitingSince = useReviewQueueCount(enabled).newestWaitingSince;
    useEffect(function () {
        if (enabled) {
            markReviewQueueSeen(userId, newestWaitingSince);
        }
    }, [enabled, userId, newestWaitingSince]);
};
